import {DialogProps} from 'packages/common-types/base-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import {Button} from '@material-ui/core';
import Swal from 'sweetalert2';
import {useMutation} from '@apollo/client';
import {DELETE_CLUB} from 'packages/graphql/v2/mutations';
import {GET_CLUBS, GET_USERS} from 'packages/graphql/v2/queries';
import {Club} from 'packages/common-types/schema-types';

type Props = DialogProps & {
  clubId: string;
};

type MutVars = {
  clubId: string;
};

type MutData = {
  deleteClub: Club;
};

const DeleteClub = (props: Props) => {
  const {modalOpen, toggle, clubId} = props;
  const [deleteClub, {loading}] = useMutation<MutData, MutVars>(DELETE_CLUB);

  const handleDeleteClub = async () => {
    try {
      await deleteClub({
        variables: {clubId},
        refetchQueries: [
          {
            query: GET_CLUBS,
          },
          {
            query: GET_USERS,
          },
        ],
      });
      Swal.fire({
        title: 'Hecho',
        text: 'Club eliminado exitosamente.',
        icon: 'success',
      });
      toggle();
    } catch (error) {
      console.error('ERROR => ', error);
      Swal.fire({
        title: 'Error',
        text: 'No se puede eliminar el club.',
        icon: 'error',
      });
      toggle();
    }
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={toggle}
      aria-labelledby="dialog-delete-club"
    >
      <DialogTitle id="">
        ¿Estas seguro de que deseas eliminar un club?
      </DialogTitle>
      <DialogContent>
        {loading && <LinearProgress />}
        <DialogContentText>
          El eliminar un club puede causar conflictos en el ranking nacional de
          los participantes que esten jugando un torneo actualmente.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancel
        </Button>
        <Button onClick={handleDeleteClub} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteClub;
